// extracted by mini-css-extract-plugin
export default {"text":"MyText_text__P28rd"};